export const invoiceStatus = {
    PENDING:"در انتظار بررسی",
    PROCESSING:"در حال انجام",
    CANCELLED:"لغو شده",
    NEED_REVIEW:"نیازمند بررسی",
    COMPLETED:"تکمیل",
    REFUNDED:"باز پرداخت شده",
    FAILED:"دارای ایراد",
    DRAFT:"پیشنویس یا سبد خرید"

}
